import React from 'react';
import { useGetEventCTAButtonsDataLazyQuery, useEventWebsiteGuestLazyQuery, EventDesignPurpose } from '@graphql/generated';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useDisclosure } from '@withjoy/joykit';
import { useMediaQuery } from '@withjoy/joykit/utils';
import { useEffect } from 'react';
import { GuestGuideContent } from './GuestGuideContent';
import { GuestGuideTelemetryProvider } from './GuestGuideTelemetry';
import { GuestGuideTrigger } from './GuestGuideTrigger';
import { DesktopWrapper, MobileWrapper } from './GuestGuideWrappers';
import { ReminderModalProvider } from './ReminderModalContext';
import { ReminderModalWrapper } from './ReminderModalWrapper';
import { BreakpointAliasKey } from '@withjoy/joykit/theme';

const ALOHA_BREAKPOINT: BreakpointAliasKey = 'sm4';

const GuestGuideModal: React.FC<{ sessionData: ReturnType<typeof useGetEventCTAButtonsDataLazyQuery>[1]['data'] | undefined }> = ({ sessionData }) => {
  const { eventHandle, eventInfo } = useEventInfo();
  const rsvpAttendanceStatus = sessionData?.eventByName?.activeSession?.eventCTA?.rsvpAttendanceStatus;

  const [getEventData, { data: eventData }] = useEventWebsiteGuestLazyQuery({
    batchMode: 'fast',
    ssr: false,
    fetchPolicy: 'cache-only',
  });

  useEffect(() => {
    if (eventHandle) {
      getEventData({
        variables: {
          eventDesignPurpose: EventDesignPurpose.live,
          eventHandle: eventHandle,
          isAdminDashboard: false,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventHandle]);

  const isDesktop = useMediaQuery(theme => theme.mediaQueries.up({ breakpointAlias: ALOHA_BREAKPOINT }));
  const { isOpen: isGuestGuideOpen, onOpen: onGuestGuideOpen, onClose: onGuestGuideClose } = useDisclosure();

  const countDownDateMs =
    eventData?.eventByName?.settings?.hideEventCountdown !== true && eventInfo?.finalizedDate?.milliseconds != null ? eventInfo.finalizedDate.milliseconds : undefined;
  const countDownDateInThePast = countDownDateMs != null ? countDownDateMs < Date.now() : false;
  const countDownDate = countDownDateMs != null && !countDownDateInThePast ? countDownDateMs : undefined;

  const guestGuideContent = (
    <GuestGuideContent
      countDownDate={countDownDate}
      sessionData={sessionData}
    />
  );

  return (
    <GuestGuideTelemetryProvider>
      <ReminderModalProvider>
        <>
          {isDesktop ? (
            <DesktopWrapper
              trigger={
                <GuestGuideTrigger
                  rsvpAttendanceStatus={rsvpAttendanceStatus}
                  eventHandle={eventHandle}
                />
              }
              isOpen={isGuestGuideOpen}
              onOpen={onGuestGuideOpen}
              onClose={onGuestGuideClose}
            >
              {guestGuideContent}
            </DesktopWrapper>
          ) : (
            <MobileWrapper
              trigger={
                <GuestGuideTrigger
                  rsvpAttendanceStatus={rsvpAttendanceStatus}
                  eventHandle={eventHandle}
                />
              }
              isOpen={isGuestGuideOpen}
              onOpen={onGuestGuideOpen}
              onClose={onGuestGuideClose}
            >
              {guestGuideContent}
            </MobileWrapper>
          )}
        </>
        <ReminderModalWrapper />
      </ReminderModalProvider>
    </GuestGuideTelemetryProvider>
  );
};

export default GuestGuideModal;
